export const SAVE_I130_BIOGRAPHICS_STARTED = "SAVE_I130_BIOGRAPHICS_STARTED";
export const SAVE_I130_BIOGRAPHICS_SUCCESS = "SAVE_I130_BIOGRAPHICS_SUCCESS";
export const SAVE_I130_BIOGRAPHICS_FAILED = "SAVE_I130_BIOGRAPHICS_FAILED";
 
export const UPDATE_I130_BIOGRAPHICS_STARTED = "UPDATE_I130_BIOGRAPHICS_STARTED";
export const UPDATE_I130_BIOGRAPHICS_SUCCESS = "UPDATE_I130_BIOGRAPHICS_SUCCESS";
export const UPDATE_I130_BIOGRAPHICS_FAILED = "UPDATE_I130_BIOGRAPHICS_FAILED";
  
export const GET_I130_BIOGRAPHICS_STARTED = "GET_I130_BIOGRAPHICS_STARTED";
export const GET_I130_BIOGRAPHICS_SUCCESS = "GET_I130_BIOGRAPHICS_SUCCESS";
export const GET_I130_BIOGRAPHICS_FAILED = "GET_I130_BIOGRAPHICS_FAILED";

export const SAVE_I130FORMS_STARTED = "SAVE_I130FORMS_STARTED";
export const SAVE_I130FORMS_SUCCESS = "SAVE_I130FORMS_SUCCESS";
export const SAVE_I130FORMS_FAILED = "SAVE_I130FORMS_FAILED";
 
export const UPDATE_I130FORMS_STARTED = "UPDATE_I130FORMS_STARTED";
export const UPDATE_I130FORMS_SUCCESS = "UPDATE_I130FORMS_SUCCESS";
export const UPDATE_I130FORMS_FAILED = "UPDATE_I130FORMS_FAILED";

export const GET_I130FORMS_STARTED = "GET_I130FORMS_STARTED";
export const GET_I130FORMS_SUCCESS = "GET_I130FORMS_SUCCESS";
export const GET_I130FORMS_FAILED = "GET_I130FORMS_FAILED";

export const SAVEPDF_I130FORMS_SUCCESS = "SAVEPDF_I130FORMS_SUCCESS";
export const SAVEPDF_I130FORMS_FAILED = "SAVEPDF_I130FORMS_FAILED";
export const SAVEPDF_I130FORMS_STARTED = "SAVEPDF_I130FORMS_STARTED";

export const SAVE_I130AFORMS_STARTED = "SAVE_I130AFORMS_STARTED";
export const SAVE_I130AFORMS_SUCCESS = "SAVE_I130AFORMS_SUCCESS";
export const SAVE_I130AFORMS_FAILED = "SAVE_I130AFORMS_FAILED";
 
export const UPDATE_I130AFORMS_STARTED = "UPDATE_I130AFORMS_STARTED";
export const UPDATE_I130AFORMS_SUCCESS = "UPDATE_I130AFORMS_SUCCESS";
export const UPDATE_I130AFORMS_FAILED = "UPDATE_I130AFORMS_FAILED";

export const GET_I130AFORMS_STARTED = "GET_I130AFORMS_STARTED";
export const GET_I130AFORMS_SUCCESS = "GET_I130AFORMS_SUCCESS";
export const GET_I130AFORMS_FAILED = "GET_I130AFORMS_FAILED";

export const SAVEPDF_I130AFORMS_SUCCESS = "SAVEPDF_I130AFORMS_SUCCESS";
export const SAVEPDF_I130AFORMS_FAILED = "SAVEPDF_I130AFORMS_FAILED";
export const SAVEPDF_I130AFORMS_STARTED = "SAVEPDF_I130AFORMS_STARTED";

export const SAVE_I131FORMS_STARTED = "SAVE_I131FORMS_STARTED";
export const SAVE_I131FORMS_SUCCESS = "SAVE_I131FORMS_SUCCESS";
export const SAVE_I131FORMS_FAILED = "SAVE_I131FORMS_FAILED";
 
export const UPDATE_I131FORMS_STARTED = "UPDATE_I131ORMS_STARTED";
export const UPDATE_I131FORMS_SUCCESS = "UPDATE_I131FORMS_SUCCESS";
export const UPDATE_I131FORMS_FAILED = "UPDATE_I131FORMS_FAILED";

export const GET_I131FORMS_STARTED = "GET_I131FORMS_STARTED";
export const GET_I131FORMS_SUCCESS = "GET_I131FORMS_SUCCESS";
export const GET_I131FORMS_FAILED = "GET_I131FORMS_FAILED";

export const SAVEPDF_I131FORMS_SUCCESS = "SAVEPDF_I131FORMS_SUCCESS";
export const SAVEPDF_I131FORMS_FAILED = "SAVEPDF_I131FORMS_FAILED";
export const SAVEPDF_I131FORMS_STARTED = "SAVEPDF_I131FORMS_STARTED";

export const SAVE_I864FORMS_STARTED = "SAVE_I864FORMS_STARTED";
export const SAVE_I864FORMS_SUCCESS = "SAVE_I864FORMS_SUCCESS";
export const SAVE_I864FORMS_FAILED = "SAVE_I864FORMS_FAILED";
 
export const UPDATE_I864FORMS_STARTED = "UPDATE_I864ORMS_STARTED";
export const UPDATE_I864FORMS_SUCCESS = "UPDATE_I864FORMS_SUCCESS";
export const UPDATE_I864FORMS_FAILED = "UPDATE_I864FORMS_FAILED";

export const GET_I864FORMS_STARTED = "GET_I864FORMS_STARTED";
export const GET_I864FORMS_SUCCESS = "GET_I864FORMS_SUCCESS";
export const GET_I864FORMS_FAILED = "GET_I864FORMS_FAILED";

export const SAVEPDF_I864FORMS_SUCCESS = "SAVEPDF_I864FORMS_SUCCESS";
export const SAVEPDF_I864FORMS_FAILED = "SAVEPDF_I864FORMS_FAILED";
export const SAVEPDF_I864FORMS_STARTED = "SAVEPDF_I864FORMS_STARTED";


export const SAVE_I485FORMS_STARTED = "SAVE_I485FORMS_STARTED";
export const SAVE_I485FORMS_SUCCESS = "SAVE_I485FORMS_SUCCESS";
export const SAVE_I485FORMS_FAILED = "SAVE_I485FORMS_FAILED";
 
export const UPDATE_I485FORMS_STARTED = "UPDATE_I485ORMS_STARTED";
export const UPDATE_I485FORMS_SUCCESS = "UPDATE_I485FORMS_SUCCESS";
export const UPDATE_I485FORMS_FAILED = "UPDATE_I485FORMS_FAILED";

export const GET_I485FORMS_STARTED = "GET_I485FORMS_STARTED";
export const GET_I485FORMS_SUCCESS = "GET_I485FORMS_SUCCESS";
export const GET_I485FORMS_FAILED = "GET_I485FORMS_FAILED";

export const SAVEPDF_I485FORMS_SUCCESS = "SAVEPDF_I485FORMS_SUCCESS";
export const SAVEPDF_I485FORMS_FAILED = "SAVEPDF_I485FORMS_FAILED";
export const SAVEPDF_I485FORMS_STARTED = "SAVEPDF_I485FORMS_STARTED";

export interface II130Case {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    CaseInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}

export const biographicsCreate = (biographicsCreateInput: any) => {
 
    return {
        type: SAVE_I130_BIOGRAPHICS_STARTED,
        payload: 'status',
        input: biographicsCreateInput
    };
};

export const biographicsUpdate = (biographicsUpdateInput: any) => {

   return {
       type: UPDATE_I130_BIOGRAPHICS_STARTED,
       payload: 'status',
       input: biographicsUpdateInput
   };

};

export const getBiographicsDetails = (biographicsInput: any) => {

    return {
        type: GET_I130_BIOGRAPHICS_STARTED,
        payload: 'status',
        input: biographicsInput
    };
 
 };
 
export const i130formsCreate = (i130formsCreateInput: any) => {
 
    return {
        type: SAVE_I130FORMS_STARTED,
        payload: 'status',
        input: i130formsCreateInput
    };
};

export const i130formsUpdate = (i130formsUpdateInput: any) => {

   return {
       type: UPDATE_I130FORMS_STARTED,
       payload: 'status',
       input: i130formsUpdateInput
   };

};
export const getI130formsDetails = (caseId) => {
   
    return {
        type: GET_I130FORMS_STARTED ,
        payload: 'Value',
        input:caseId,
    };
}; 

export const i130FormPdfSubmit = (caseId) => {
 
    return {
        type: SAVEPDF_I130FORMS_STARTED,
        payload: 'Value',
        input:caseId
    };
};

export const i130AformsCreate = (i130formsCreateInput: any) => {
 
    return {
        type: SAVE_I130AFORMS_STARTED,
        payload: 'status',
        input: i130formsCreateInput
    };
};

export const i130AformsUpdate = (i130formsUpdateInput: any) => {

   return {
       type: UPDATE_I130AFORMS_STARTED,
       payload: 'status',
       input: i130formsUpdateInput
   };

};
export const getI130AformsDetails = (caseId) => {
   
    return {
        type: GET_I130AFORMS_STARTED ,
        payload: 'Value',
        input:caseId,
    };
}; 

export const i130AFormPdfSubmit = (caseId) => {
 
    return {
        type: SAVEPDF_I130AFORMS_STARTED,
        payload: 'Value',
        input:caseId
    };
};

export const i131formsCreate = (i131formsCreateInput: any) => {
 
    return {
        type: SAVE_I131FORMS_STARTED,
        payload: 'status',
        input: i131formsCreateInput
    };
};

export const i131formsUpdate = (i131formsUpdateInput: any) => {

   return {
       type: UPDATE_I131FORMS_STARTED,
       payload: 'status',
       input: i131formsUpdateInput
   };

};
export const getI131formsDetails = (i131formsUpdateInput: any) => {
   
    return {
        type: GET_I131FORMS_STARTED ,
        payload: 'Value',
        input:i131formsUpdateInput 
    };
};

export const i131FormPdfSubmit = (caseId) => {
 
    return {
        type: SAVEPDF_I131FORMS_STARTED,
        payload: 'Value',
        input:caseId
    };
};

export const i864formsCreate = (i864formsCreateInput: any) => {
 
    return {
        type: SAVE_I864FORMS_STARTED,
        payload: 'status',
        input: i864formsCreateInput
    };
};

export const i864formsUpdate = (i864formsUpdateInput: any) => {

   return {
       type: UPDATE_I864FORMS_STARTED,
       payload: 'status',
       input: i864formsUpdateInput
   };

};
export const getI864formsDetails = (i864formsUpdateInput: any) => {
   
    return {
        type: GET_I864FORMS_STARTED ,
        payload: 'Value',
        input:i864formsUpdateInput 
    };
};

export const i864FormPdfSubmit = (caseId) => {
 
    return {
        type: SAVEPDF_I864FORMS_STARTED,
        payload: 'Value',
        input:caseId
    };
};

export const i485formsCreate = (i485formsCreateInput: any) => {
 
    return {
        type: SAVE_I485FORMS_STARTED,
        payload: 'status',
        input: i485formsCreateInput
    };
};

export const i485formsUpdate = (i485formsUpdateInput: any) => {

   return {
       type: UPDATE_I485FORMS_STARTED,
       payload: 'status',
       input: i485formsUpdateInput
   };

};
export const getI485formsDetails = (i485formsUpdateInput: any) => {
   
    return {
        type: GET_I485FORMS_STARTED ,
        payload: 'Value',
        input:i485formsUpdateInput 
    };
};

export const i485FormPdfSubmit = (caseId) => {
 
    return {
        type: SAVEPDF_I485FORMS_STARTED,
        payload: 'Value',
        input:caseId
    };
};